// import { gql } from "@apollo/client/core";
import { gql } from "@apollo/react-hooks";

export const GET_SINGLE_USER = gql`
  query getSingleUser($userId: ID!) {
    getSingleUser(userId: $userId) {
      id
      uid
      username
      wallet_address
      email
      balance
      expirience
      avatar_url
      created_at
      avatar_generated
      has_password
      email_activated
      is_staff
      referral_code
      statistics {
        total {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
        blackjack {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
        coinflip {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
        jackpot {
          total
          games_won
          games_lose
          profits
          wagered
          max_profit
        }
      }
      policies {
        key
        value
        expire_at
      }
      social_media {
        facebook {
          _
        }
        twitch {
          _
        }
        twitter {
          _
        }
        youtube {
          _
        }
        discord {
          _
        }
      }
    }
  }
`;

export const GET_USER_TRANSACTIONS = gql`
  query getUserTransactions($userId: ID!) {
    getUserTransactions(userId: $userId) {
      user
      id
      withdraws {
        wallet_address
        ammount
        points_equivalent
        signature
        solscan_url
        timestamp
      }
      deposits {
        wallet_address
        ammount
        points_equivalent
        signature
        solscan_url
        timestamp
      }
    }
  }
`;

export const GET_COINFLIP_GAMES = gql`
  query {
    getAllCoinflipGames {
      game_metadata {
        creator {
          uid
          username
          is_staff
          avatar_url
          id
          expirience
        }
        created_at
        status
        started_at
        ended_at
        max_players
        is_private
      }
      uid
      tails_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      heads_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      stake
      reward
      roll
      result
      ticket_id
      ticket_hash
      ticket_verify_url
    }
  }
`;

export const GET_SINGLE_COINFLIP_GAME = gql`
  query getSingleCoinflipGame($uid: String!) {
    getSingleCoinflipGame(uid: $uid) {
      game_metadata {
        creator {
          uid
          username
          is_staff
          avatar_url
          id
          expirience
        }
        created_at
        status
        started_at
        ended_at
        max_players
        is_private
      }
      uid
      tails_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      heads_user {
        uid
        username
        is_staff
        avatar_url
        id
        expirience
      }
      stake
      reward
      roll
      result
      ticket_id
      ticket_hash
      ticket_verify_url
    }
  }
`;

export const GET_JACKPOT_LOBBY = gql`
  query {
    lobby: getJackpotLobby {
      rooms {
        title
        slug
        min_stake
        max_stake
        max_stakes_count
        max_stakes_per_user
        countdown_to_bet
        countdown_to_new_game
        current_game {
          game_metadata {
            creator {
              id
              username
              is_staff
              avatar_url
              expirience
            }
            max_players
            is_private
            created_at
            started_at
            ended_at
            status
          }
          players_joined
          uid
          total_stakes
          bank
          roll
          roll_stake
          reward
          ticket_id
          ticket_hash
          ticket_verify_url
          players {
            total_stake
            total_stakes
            user {
              id
              username
              is_staff
              avatar_url
              expirience
            }
          }
          stakes {
            stake
            userId
            timestamp
          }
          winner_id
        }
        recent_games {
          game_metadata {
            creator {
              id
              username
              is_staff
              avatar_url
              expirience
            }
            max_players
            is_private
            created_at
            started_at
            ended_at
            status
          }
          uid
          players_joined
          total_stakes
          bank
          roll
          roll_stake
          reward
          ticket_id
          ticket_hash
          ticket_verify_url
          players {
            user {
              id
              username
              is_staff
              avatar_url
              expirience
            }
            total_stake
            total_stakes
          }
          stakes {
            stake
            userId
            timestamp
          }
          winner_id
        }
      }
    }
  }
`;

export const GET_BLACKJACK_LOBBY = gql`
  query {
    lobby: getBlackjackLobby {
      max_stake
      min_stake
      rooms {
        title
        max_players
        current_game {
          game_metadata {
            max_players
            creator {
              username
              id
              is_staff
              uid
              avatar_url
              expirience
            }
            started_at
            created_at
            ended_at
            status
          }
          uid
          players {
            user {
              username
              uid
              id
              is_staff
              expirience
              avatar_url
            }
            points
            ready_to_play
            status
            winner
            reward
            cards {
              type
              order
            }
            tickets {
              userId
              ticket_id
              ticket_hash
              ticket_verify_url
              order
              roll
              card_index
              activated_at
            }
            joined_at
          }
          prepay_rate
          prepay_amount
          cost
          referral_stakes_periods
          referral_wagered_in_period
          cards_order
          ticket_id
          ticket_hash
          ticket_verify_url
          secret_hash
        }
        recent_games {
          game_metadata {
            status
            max_players
            creator {
              username
              id
              is_staff
              uid
              avatar_url
              expirience
            }
            started_at
            created_at
            ended_at
            status
          }
          uid
          cost
          cards_order
          secret_hash
          prepay_rate
          prepay_amount
          referral_stakes_periods
          referral_wagered_in_period
          cards_order

          players {
            user {
              username
              uid
              id
              is_staff
              expirience
              avatar_url
            }
            points
            ready_to_play
            status
            winner
            reward
            cards {
              type
              order
            }
            tickets {
              userId
              ticket_id
              ticket_hash
              ticket_verify_url
              order
              roll
              card_index
              activated_at
            }
            joined_at
          }
        }
      }
    }
  }
`;

export const GET_SINGLE_BLACKJACK_GAME = gql`
  query ($uid: String!) {
    info: getSingleBlackjackGame(uid: $uid) {
      game_metadata {
        status
        max_players
        creator {
          username
          id
          is_staff
          uid
          avatar_url
          expirience
        }
        started_at
        created_at
        ended_at
        status
      }
      uid
      cost
      cards_order
      secret_hash
      prepay_rate
      prepay_amount
      referral_stakes_periods
      referral_wagered_in_period
      cards_order

      players {
        user {
          username
          uid
          id
          is_staff
          expirience
          avatar_url
        }
        points
        ready_to_play
        status
        winner
        reward
        cards {
          type
          order
        }
        tickets {
          userId
          ticket_id
          ticket_hash
          ticket_verify_url
          order
          roll
          card_index
          activated_at
        }
        joined_at
      }
    }
  }
`;
